<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert v-if="errorOccurred" color="danger" title="Classroom Not Found">
      <span>Classroom record with id:  not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'admin-list-classrooms'}"
                                        class="text-inherit underline">All Classrooms</router-link>
      </span>
    </vs-alert>

    <div v-if="classroomData" class="flex justify-center">

      <div style="width: 100%; max-width: 92.5rem">

        <!--- CLASSROOM HEADER START --->
        <classroom-top-bar :classroom-id="classroomData.id" :color="classroomData.color" :tab="activeTab"
                           @refresh="fetchInit" @updateTab="updateTab"/>
        <!--- CLASSROOM HEADER END --->

        <!--- CLASSROOM STREAM START --->
        <classroom-stream-tab :classroom-data="classroomData" :classroom-stream-data="classroomStreamData" :classroom-id="classroomId"
                              @updateTab="updateTab" @refresh="fetchInit" v-if="activeTab === 0"/>
        <!--- CLASSROOM STREAM END --->

        <!--- CLASSROOM MATERIAL START --->
        <classroom-assignments-tab :classroom-data="classroomData" :classroom-id="classroomId"
                                @updateTab="updateTab" v-if="activeTab === 1"/>
        <!--- CLASSROOM MATERIAL END --->

        <!--- CLASSROOM MATERIAL START --->
        <classroom-material-tab :classroom-data="classroomData" :classroom-id="classroomId"
                               @updateTab="updateTab" v-if="activeTab === 2"/>
        <!--- CLASSROOM MATERIAL END --->

        <!--- CLASSROOM MEETINGS START --->
        <classroom-meeting-tab :classroom-data="classroomData" :classroom-id="classroomId"
                               @updateTab="updateTab" v-if="activeTab === 3"/>
        <!--- CLASSROOM MEETINGS END --->

      </div>

    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import ClassroomTopBar from './tabs/ClassroomTopBar'
import ClassroomStreamTab from './tabs/ClassroomStreamTab'
import ClassroomAssignmentsTab from './tabs/ClassroomAssignmentsTab'
import ClassroomMaterialTab from './tabs/ClassroomMaterialTab'
import ClassroomMeetingTab from './tabs/ClassroomMeetingTab'


export default {
  data () {
    return {
      activeTab: 0,

      classroomId: null,
      classroomData: null,
      classroomStreamData: null,
      classroomInviteData: null,

      errorOccurred: false
    }
  },
  components: {
    Prism,
    vSelect,
    Datepicker,
    ClassroomTopBar,
    ClassroomStreamTab,
    ClassroomMaterialTab,
    ClassroomMeetingTab,
    ClassroomAssignmentsTab
  },
  methods: {
    fetchClassroomDetails (id) {
      this.$http.get(`app/classroom/${id}/properties`)
        .then(response => {

          if (response.status === 200) {
            this.classroomData = response.data.data.properties
            this.classroomStreamData = response.data.data.stream
            this.classroomInviteData = response.data.data.invite
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    fetchInit () {
      const id = this.$route.params.classroomId
      this.classroomId = id
      this.fetchClassroomDetails(id)
    },
    updateTab (id) {
      this.activeTab = id
    }
  },
  created () {
    this.fetchInit()
  }
}

</script>
<style lang="scss">
</style>
